<template>
<!-- <v-dialog dark v-model="sysmsg" persistent max-width="320">
    <v-card>
      <v-card-title>{{sysmsgTitle}}</v-card-title>
      <v-card-text>{{sysmsgText}}</v-card-text>
      <v-card-actions>        
        <v-btn color="primary darken-1 btn-height-custom" @click.native="$emit('onConfirmSysmsg')">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
  
  <!--2020/10/21 203665 Change the dialog show error message  -->
   <dialogWindow
      ref="errorCommonDialog"
      size="max"
      :title="sysmsgTitle"
      :detail="sysmsgText"
      color="error"
      @select-ok="$emit('onConfirmSysmsg')"
    >
    </dialogWindow>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'

export default {
    name: 'system-message',
    components: {
      dialogWindow
    },
    props: {     
      sysmsgText: {
            default: ''
      }, 
      sysmsgTitle: {
            default: ''
      }, 
      sysmsg: {
            default: false
      }      
    },
    data () {
      return {
        mini: false,
        isRootComponent: true,
        // clipped: false,
        drawer: true,
        fixed: false
      }
    },
    methods: {
      onConfirmSysmsg () {}      
    },
    mounted () {
    },
    watch: {
      sysmsg: {
        handler: function () {
            if(this.sysmsg){
              this.$refs.errorCommonDialog.dialog = true;
            }else{
              this.$refs.errorCommonDialog.dialog = false;  
            }
        },
        deep: true
      }
    }
  }
</script>
